export  function locationSlider() {
    const locations = $(".location");
    locations.each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
        const mobileMapBg = curSliderWrap.closest(".location-section").find(".mobile-bg");

        let swiperOptions = {
            watchOverflow: true,
            slidesPerView: 'auto',
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);

        swiper.on('slideChange', function (e) {
            const currentSlider = swiper.slides[swiper.activeIndex];
            const srcMap = $(currentSlider).data("mobile-map");
            const currentBgSrc = mobileMapBg.attr("src").split("/");
            currentBgSrc[currentBgSrc.length - 1] = srcMap + ".svg";
            mobileMapBg.fadeOut(500, function() {
                mobileMapBg.attr("src", currentBgSrc.join("/"));
            }).fadeIn(500);
        });

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/locationSlider.js